<template>
  <div class="fadeIn" v-if="report">
    <ManagerPrint id="print" :report="report" />
    <b-card>
      <div slot="header">
        <strong>Отчет по менеджеру {{report.user.fullname}} о статусе верификации компаний (с перечнем компаний)</strong>
      </div>
      <b-row>
        <b-col md="8">
          <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
              <th>Верификация</th>
              <th>Участники инф. мероприятия</th>
              <th>Кандидат</th>
              <th>Архив</th>
              <th>Итого</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{report.total.verify}}</td>
              <td>{{report.total.event}}</td>
              <td>{{report.total.candidate}}</td>
              <td>{{report.total.archive}}</td>
              <td>{{report.total.all}}</td>
            </tr>
            </tbody>
          </table>
          <hr/>
          <b-table striped hover bordered responsive="sm" class="table-align-middle mb-0" :items="report.companies" :fields="fields"></b-table>
        </b-col>
        <b-col md="4">
          <ManagerDoughutChart chartId="chart-managers" :data="[report.total.verify, report.total.event, report.total.candidate, report.total.archive]"></ManagerDoughutChart>
        </b-col>
      </b-row>
      <div slot="footer">
        <div class="text-right">
          <b-button variant="info" @click="print('admin')" class="text-white">
            <i class="fa fa-print"></i> Печать
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
    import client from "../../backend/client";
    import ManagerDoughutChart from "../charts/ManagerDoughutChart";
    import ManagerPrint from "./ManagerPrint";
    export default {
        name: "Manager",
        components: {ManagerPrint, ManagerDoughutChart},
        data() {
            return {
                regionId: null,
                userId: null,
                report: null,
                fields: [
                    {
                        key: 'name',
                        label: 'Название',
                        sortable: true
                    },
                    {
                        key: 'ogrn',
                        label: 'ОГРН',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Статус',
                        sortable: true
                    }
              ]
            }
        },
        mounted() {
            this.regionId = this.$route.params.region;
            this.userId = this.$route.params.user;
            client
                .get('api/crm/reports/' + this.regionId + '/manager', {
                  params: {
                    userId: this.userId
                  }
                })
                .then(res => {
                    this.report = res.data
                })
        },
        methods: {
            print() {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;} body{ margin: 10mm 5mm 5mm 25mm; }</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById('print').innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            },
        }
    }
</script>

<style scoped>
  #print {
    display: none;
  }
</style>
